import { ArrowUpRight, Globe, Instagram, MapPin } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const NATIONAL = {
  name: "ELSA Belgium",
  url: "https://elsa-belgium.org",
  label: "elsa-belgium.org",
};

const CHAPTERS = [
  { name: "ELSA Antwerpen", url: "https://elsaantwerpen.be", label: "elsaantwerpen.be", type: "web" },
  { name: "ELSA Brussels", url: "https://www.instagram.com/elsabrussels/?hl=nl", label: "@elsabrussels", type: "insta" },
  { name: "ELSA Brussel", url: "https://www.instagram.com/elsa_brussel/?hl=nl", label: "@elsa_brussel", type: "insta", current: true },
  { name: "ELSA Gent", url: "https://gent.elsa-belgium.org", label: "gent.elsa-belgium.org", type: "web" },
  { name: "ELSA Hasselt", url: "https://www.instagram.com/elsahasselt/?hl=nl", label: "@elsahasselt", type: "insta" },
  { name: "ELSA Liège", url: "https://www.instagram.com/elsaliege/?hl=nl", label: "@elsaliege", type: "insta" },
  { name: "ELSA Leuven", url: "https://elsaleuven.be", label: "elsaleuven.be", type: "web" },
  { name: "ELSA Louvain-la-Neuve", url: "https://lln.elsa-belgium.org", label: "lln.elsa-belgium.org", type: "web" },
  { name: "ELSA Namur", url: "https://www.instagram.com/elsa_namur/?hl=nl", label: "@elsa_namur", type: "insta" },
  { name: "ELSA Saint-Louis", url: "https://elsa-saintlouis.be", label: "elsa-saintlouis.be", type: "web" },
];

export default function Netwerk() {
  return (
    <div data-testid="netwerk-page">
      <PageHero
        eyebrow="Eén netwerk, negen steden"
        title={<>ELSA in<br />België.</>}
        subtitle="ELSA Brussel maakt deel uit van ELSA Belgium — een landelijk netwerk van lokale afdelingen die samen de grootste onafhankelijke rechtenstudentenvereniging van Europa vormen."
        testid="netwerk-hero"
      />

      {/* NATIONAAL */}
      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 py-20">
        <Reveal>
          <a
            href={NATIONAL.url}
            target="_blank"
            rel="noreferrer"
            data-testid="netwerk-national"
            className="group grid md:grid-cols-12 gap-8 items-center border border-black/10 bg-white p-8 md:p-12 transition-colors hover:bg-[#F9F9F6]"
          >
            <div className="md:col-span-8">
              <p className="text-sm tracking-[0.25em] uppercase mb-3" style={{ color: "var(--elsa-grey)" }}>Nationaal bestuur</p>
              <h2 className="font-serif text-4xl md:text-5xl text-[#0B0B0C] mb-3">{NATIONAL.name}</h2>
              <p className="text-muted-foreground max-w-xl text-balance">
                Het overkoepelende bestuur dat de negen Belgische afdelingen verbindt en vertegenwoordigt binnen
                het internationale ELSA-netwerk.
              </p>
            </div>
            <div className="md:col-span-4 md:text-right">
              <span className="inline-flex items-center gap-2 text-sm font-600 text-[#0A3087]">
                {NATIONAL.label}
                <ArrowUpRight size={17} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </div>
          </a>
        </Reveal>

        {/* LOKALE AFDELINGEN */}
        <div className="mt-20">
          <Reveal>
            <div className="flex items-center gap-4 mb-8">
              <span className="h-2 w-2 rounded-full" style={{ background: "var(--elsa-blue)" }} />
              <h2 className="text-sm tracking-[0.25em] uppercase text-muted-foreground">Lokale afdelingen</h2>
            </div>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.name} delay={(i % 3) * 0.06}>
                <a
                  href={c.url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`netwerk-chapter-${i}`}
                  className={`group relative flex flex-col justify-between h-44 p-7 transition-colors ${
                    c.current ? "bg-[#0A3087] text-white" : "bg-white hover:bg-[#F9F9F6]"
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <MapPin size={18} className={c.current ? "text-white/70" : "text-[#0A3087]"} />
                    {c.current && (
                      <span className="text-[10px] font-600 uppercase tracking-widest px-2.5 py-1 rounded-full bg-white text-[#0A3087]">Jij bent hier</span>
                    )}
                  </div>
                  <div>
                    <h3 className={`font-serif text-2xl mb-2 ${c.current ? "text-white" : "text-[#0B0B0C]"}`}>{c.name}</h3>
                    <span className={`inline-flex items-center gap-1.5 text-sm ${c.current ? "text-white/80" : "text-muted-foreground group-hover:text-[#0A3087]"} transition-colors`}>
                      {c.type === "insta" ? <Instagram size={14} /> : <Globe size={14} />}
                      {c.label}
                      <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
